(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-shipping-confetti"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sfny-drawer-shipping-celebration')) {
    customElements.define('sfny-drawer-shipping-celebration', class extends HTMLElement {
      connectedCallback() {
        this.drawer = this.previousElementSibling;
        if (!this.drawer?.matches('cart-drawer')) return;

        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotionChange = () => {
          if (this.motionPreference.matches) {
            this.pendingCelebration = false;
            this.clearConfetti();
          }
        };
        this.motionPreference.addEventListener('change', this.onMotionChange);
        this.wasQualified = this.isQualified();
        this.pendingCelebration = false;
        this.observer = new MutationObserver(() => {
          const qualified = this.isQualified();
          const crossedThreshold = qualified && !this.wasQualified;
          this.wasQualified = qualified;

          if (!qualified) {
            this.pendingCelebration = false;
            this.clearConfetti();
          } else if (crossedThreshold) {
            this.pendingCelebration = !this.motionPreference.matches && !document.hidden;
          }

          if (!this.drawer.classList.contains('active')) {
            this.clearConfetti();
          } else if (this.pendingCelebration) {
            this.pendingCelebration = false;
            this.celebrate();
          }
        });
        this.observer.observe(this.drawer, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.motionPreference?.removeEventListener('change', this.onMotionChange);
        this.pendingCelebration = false;
        this.clearConfetti();
      }

      isQualified() {
        return Boolean(this.drawer.querySelector('cart-drawer-items[data-free-shipping-qualified="true"]'));
      }

      clearConfetti() {
        window.clearTimeout(this.cleanupTimer);
        this.querySelectorAll('span').forEach((particle) => {
          particle.getAnimations().forEach((animation) => animation.cancel());
        });
        this.replaceChildren();
      }

      celebrate() {
        if (this.motionPreference.matches || document.hidden || !Element.prototype.animate) return;

        const bar = this.drawer.querySelector('.cart-drawer__free-shipping-track');
        if (!bar) return;

        this.clearConfetti();
        const rect = bar.getBoundingClientRect();
        const width = document.documentElement.clientWidth;
        const height = document.documentElement.clientHeight;
        const y = Math.max(100, Math.min(height - 100, rect.top));
        const edgePadding = Math.max(16, width * 0.035);
        const spread = Math.min(90, width * 0.12);
        const colors = ['#b9a477', '#d8cdb7', '#aaa69f', '#484641'];
        const count = width < 750 ? 20 : 32;

        for (let index = 0; index < count; index += 1) {
          const particle = document.createElement('span');
          const x = edgePadding + ((index + 0.2 + Math.random() * 0.6) / count) * (width - edgePadding * 2);
          const targetX = Math.max(edgePadding, Math.min(width - edgePadding, x + (Math.random() * 2 - 1) * spread));
          const drift = targetX - x;
          const lift = 30 + Math.random() * 45;
          const fall = 120 + Math.random() * 80;
          const rotation = Math.random() * 240 - 120;
          particle.style.left = `${x}px`;
          particle.style.top = `${y - 35 + Math.random() * 70}px`;
          particle.style.backgroundColor = colors[index % colors.length];
          this.appendChild(particle);
          particle.animate([
            { transform: `translate(0, 0) rotate(${rotation * 0.5}deg)`, opacity: 0 },
            { transform: `translate(${drift * 0.3}px, ${-lift}px) rotate(${rotation}deg)`, opacity: 0.9, offset: 0.22 },
            { transform: `translate(${drift * 0.7}px, ${fall * 0.35}px) rotate(${rotation * 1.5}deg)`, opacity: 0.8, offset: 0.65 },
            { transform: `translate(${drift}px, ${fall}px) rotate(${rotation * 2}deg)`, opacity: 0 }
          ], {
            duration: 1800 + Math.random() * 400,
            easing: 'linear',
            fill: 'none'
          });
        }

        this.cleanupTimer = window.setTimeout(() => this.clearConfetti(), 2250);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
